import React from 'react';
import { GOOGLE_TILE_URL, SUB_DOMAIN } from '../config';
import { TileLayer } from 'react-leaflet';

const GTileLayer = () => {
    return <TileLayer url={GOOGLE_TILE_URL} subdomains={SUB_DOMAIN} maxNativeZoom={19} />;
};

export default GTileLayer;
